export default {"src":"/_next/static/media/Instagram.8b9986e7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};